// hooks/useAvevaService.ts
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import avevaApiService from '@services/avevaApiService';

export const useAvevaService = () => {
  const { instance } = useMsal();

  useEffect(() => {
    // Initialize the AVEVA service with MSAL instance
    avevaApiService.setMsalInstance(instance);
  }, [instance]);

  return avevaApiService;
};
